import { AnyAction } from "redux";
import ActionTypes from '../../../constants/ActionTypes';
import { IPakStore } from "./types";

const initialState: IPakStore = {
  cities: [],
  neighborhoods: [],
  streets: [],

};
const pakReducer = (
  state = initialState,
  action: AnyAction,
): IPakStore => {
  switch (action.type) {
  case ActionTypes.PAK.SET_CITIES:
    return {
      ...state,
      cities: action.payload
    };
  case ActionTypes.PAK.SET_NEIGHBORHOODS:
    return {
      ...state,
      neighborhoods: action.payload
    };
  case ActionTypes.PAK.SET_STREETS:
    return {
      ...state,
      streets: action.payload
    };
  }
  return state;
};

export default pakReducer;
